// Copyright © 2023 CATTLEytics Inc.

import { Auth, RoleEnum } from '../../shared';

export const isSuperAdmin = (auth: Auth): boolean => !!auth.isSuperAdmin;
export const isSiteAdminOrAbove = (auth: Auth): boolean =>
  auth.role === RoleEnum.SiteAdministrator || !!auth.isSuperAdmin;
export const isSiteAdmin = (auth: Auth): boolean => auth.role === RoleEnum.SiteAdministrator;
export const isUser = (auth: Auth): boolean => auth.role === RoleEnum.User;
